/**
 * 将字符串按一行一个格式化
 * @param  {string} str 
 * @return {array}   
 */
export function strToLineOne(str) {
  str = str.replace(/\r/ig, '');
  str = str.split('\n');
  let newStr = [];
  let clearNumber = numberClean;
  str.forEach(it => {
    if (it.trim()) {
      let itStr = clearNumber(it);
      if (itStr) {
        newStr.push(itStr);
      }
    }
  });

  return newStr;
}
/**
 * 去除oe号码种的字符
 * @param  {string} str 
 * @return {string}     
 */
export function numberClean(str) {
  if (!str) {
    return str;
  }

  let div = document.createElement('div');
  div.innerHTML = str;
  str = div.innerText || '';
  let a = str.split('');
  let b = a.filter(it => {
    return it.trim() && ['　', '.', '-', '—'].indexOf(it) == -1;
  });

  a = null;
  return b.join('');
}

// 获取元素距离body像素
export function getPositionToBody(el) {
  if (!el || typeof el == 'string') return {}
  var rect = el.getBoundingClientRect();
  var y = rect.top + (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
  var x = rect.left + (window.pageXOffset || document.documentElement.scrollLeft) - (document.documentElement.clientLeft || 0);
  return {
    x: x,
    y: y
  };
};

// 计算两个数字的乘积，结果保留2位小数位
export function multiply(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};